import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { Link } from "react-router-dom";
import { fetchImageCaptures } from "../../../lib/api/resources/imageCaptures";
import { imageCaptureColumns } from "./lib/constants/imageCaptureColumns";
import { Table } from "@/components/v2";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "@rumbledirect/ui";

export const ImageCaptureList = () => {
  const imageCapturesQuery = useQuery({
    queryKey: ["imageCaptures"],
    queryFn: async () => {
      return fetchImageCaptures();
    },
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/image-captures/create">
          <Button icon={<PlusOutlined />}>Nieuwe ImageCapture</Button>
        </Link>
      </Space>
      <Table
        columns={imageCaptureColumns}
        dataSource={imageCapturesQuery?.data}
        loading={imageCapturesQuery.isLoading}
        pagination={false}
      />
    </div>
  );
};
